<template>
  <form class="dropzone">
    <div id="dropzone-message" style="display: none">
      <span class="dropzone-title">Drop files here or <button type='button' aria-label="click to select files to upload. You may upload multiple files at once.">click to select</button></span>
      <span class="dropzone-info">You can upload multiple files at once</span>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import Dropzone from 'dropzone'
import '../../node_modules/dropzone/dist/dropzone.css'
import lambda from '../lambda'
import {eventBus} from "@/main";

Dropzone.autoDiscover = false

export default {
  name: 'dropzone',
  props: {
    bucketName: {
      type: String,
      required: true,
    },
    selectedFolder: {
      type: String,
      required: true,
    },
    bucketId: {
      type: String,
      required: true,
    }
  },
   data: () => ({
     permissions: {},
     names: [],
     errors: [],
   }),
   created() {
    let payload = {
      bucketName: this.bucketId,
    }
          
    axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'getBucketPermissions', payload)
      .then((res) => {
        this.permissions = res.data
      })
      .catch((err) => {
        console.log(err)            
      })
   },

  mounted () {
    const vm = this

    let options = {
      url: '/',
      method: 'put',
      timeout: 2200000,
      maxFilesize: 3000,

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,
      header: '',
      dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      // Here we request a signed upload URL when a file being accepted
      accept (file, done) {
        lambda.getSignedURL(file, vm.bucketName, vm.selectedFolder)
          .then((url) => {
            file.uploadURL = url
            done()
            setTimeout(() => vm.dropzone.processFile(file))
          })
          .catch((err) => {
            done('Failed to get an S3 signed upload URL', err)
          })
      }
    }

    this.dropzone = new Dropzone(this.$el, options)

    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })

    vm.dropzone.on('success', (file) => {
      eventBus.$emit('upload-complete', this.bucketName)
      this.names.push(file.name.replace(/\s/g, "_"))
      vm.dropzone.removeFile(file)
    })

    vm.dropzone.on('error', (file, message) => {
      let payload = {
        fileName: file.name,
        status: file.xhr.statusText,
        statusCode: file.xhr.status,
        error: message.split('<Message>').pop().split('</Message>')[0],
        bucketName: this.bucketName
      }
      this.errors.push(payload)
      vm.dropzone.removeFile(file)
    })

    vm.dropzone.on('queuecomplete', (file) => {
      if (vm.dropzone.getAcceptedFiles().length === 0) {
        eventBus.$emit('all-upload-complete', this.bucketId, this.names, this.errors)
        if (this.names.length > 0) {
          var uploaded = this.names.join(", ")
          const h = this.$createElement
          const nodes = h(
                  'div',
                  [
                    h('span', 'Files uploaded successfully: '),
                    h('span', uploaded)
                  ]
          )
          this.$bvToast.toast(nodes, {
            title: 'Files Uploaded Successfully',
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: 'success',
            appendToast: true
          })

          this.names = []
        }
        if (this.errors.length > 0) {
          var errs = this.errors.map(e => e.fileName).join(", ")
          const h = this.$createElement
          const nodes = h(
            'div',
              [
                h('span', 'An error has occurred while uploading files: '),
                h('span', errs)
              ]
          )
          this.$bvToast.toast(nodes, {
            title: 'Error',
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: 'danger',
            appendToast: true
          })

          this.errors = []
        }
      }
    })

  },
}
</script>

<style lang="stylus">
primaryBlue = #3498db
black = #ffffff

form.dropzone
  transition all 0.2s linear
  border 2px dashed #ccc
  background-color #fafafa
  min-height initial
  &:hover
    border-color primaryBlue
    background-color white
    .dz-message
      .dropzone-title
        color primaryBlue
  .dz-message
    color #666
    span
      line-height 1.8
      font-size 13px
      letter-spacing 0.4px
      span.dropzone-title
        display block
        color #000 !important
        font-size 1.25em
      span.dropzone-info
        display block
        color #000 !important
</style>